export const associativeStepMap = new Map<string, string>([
  ['confirmOfferStep', 'common/confirm-offer/confirm-offer-step'],
  ['recommendedOfferStep', 'common/confirm-offer/recommended-offer-step'],
  ['enterpriseIdentityStep', 'common/enterprise-section/enterprise-identity-step'],
  ['identityStep', 'common/identity-section/identity-step'],
  ['howToJoinStep', 'common/how-to-join-section/how-to-join-step'],
  ['bankAccountInfoStep', 'common/bank-account-info-section/bank-account-info-step'],
  ['summaryStep', 'common/summary-step/summary-step'],
  ['signatureStep', 'common/signature/signature'],
  ['confirmationStep', 'common/confirmation-step/confirmation-step'],
  ['confirmationBarcodeStep', 'common/confirmation-barcode-step/confirmation-barcode-step'],
  ['cancellationStep', 'common/cancellation-step/cancellation-step'],
  ['productStep', 'common/product-step/product-step'],
  ['tooLateStep', 'common/tooLate-step/tooLate-step'],
  ['tooEarlyStep', 'common/tooEarly-step/tooEarly-step'],
  ['customerInformationStep', 'common/customer-informations-step/customer-information-step'],
  ['insuredElementStep', 'common/insured-element-step/insured-element-step'],
  ['paymentStep', 'common/payment-step/payment-step'],
  ['paymentConfirmationStep', 'common/payment-confirmation/payment-confirmation-step'],
  ['paymentFailureStep', 'common/payment-failure/payment-failure-step']
]);

export const associativeGtmStepNameMap = new Map<string, string>([
  ['confirmOfferStep', 'Landing Page'],
  ['recommendedOfferStep', 'Landing Page'],
  ['enterpriseIdentityStep', 'Informations professionnelles'],
  ['identityStep', 'Informations personnelles'],
  ['howToJoinStep', 'Adresse postale'],
  ['bankAccountInfoStep', 'Coordonnées bancaires'],
  ['summaryStep', 'Récapitulatif'],
  ['signatureStep', 'Init Signature'],
  ['confirmationStep', 'Confirmation adhésion'],
  ['confirmationBarcodeStep', 'Confirmation adhésion - Code à barre'],
  ['cancellationStep', 'Annulation adhésion'],
  ['productStep', 'Product Page'],
  ['tooLateStep', 'Trop tard'],
  ['tooEarlyStep', 'Trop tôt'],
  ['paymentStep', 'Payment page'],
  ['paymentConfirmationStep', 'Payment confirmé'],
  ['paymentFailureStep', 'Payment échoué']
]);
